import { Redirect } from 'expo-router';

export default function DownloadNativeScreen() {
  return <Redirect href="/" />;
}
